import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';
import Icon from '../icon';
import Lazyload from '../lazyload';
import placeholderURL from './asset/placeholder.png';

var _createNamespace = createNamespace('image'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

var LoadingWrapper = {
    functional: true,
    render: function render(h, config) {
        var $slots = config.slots().default;
        var placeholder = config.props.placeholder;
        return config.props.show
            ? h(
                  'div',
                  {
                      class: b('loading-wrap')
                  },
                  [
                      $slots
                          ? h(
                                'div',
                                {
                                    class: b('loading')
                                },
                                [$slots]
                            )
                          : h('div', {
                                class: b('loading', ['placeholder']),
                                style: {
                                    backgroundImage: 'url('.concat(placeholder, ')')
                                }
                            })
                  ]
              )
            : '';
    }
};
var ErroredWrapper = {
    functional: true,
    render: function render(h, config) {
        return config.props.show
            ? h(
                  'div',
                  {
                      class: b('loading-wrap')
                  },
                  [
                      h(
                          'div',
                          {
                              class: b('errored')
                          },
                          [config.slots().default]
                      )
                  ]
              )
            : '';
    }
};
var InnerLazyload = {
    functional: true,
    render: function render(h, config) {
        return config.props.active
            ? h(
                  'lazyload',
                  {
                      attrs: {
                          threshold: '0.1'
                      }
                  },
                  [
                      h(
                          'template',
                          {
                              slot: 'resolved'
                          },
                          [config.slots().default]
                      )
                  ]
              )
            : config.slots().default;
    }
};
export default {
    name: getComponentName('Image'),
    data: function data() {
        return {
            isLoading: true,
            isErrored: false
        };
    },
    props: {
        src: {
            type: String
        },
        alt: {
            type: String
        },
        fillMode: {
            type: String
        },
        width: {
            type: [Number, String]
        },
        height: {
            type: [Number, String]
        },
        round: {
            type: Boolean
        },
        radius: {
            type: [Number, String]
        },
        block: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: placeholderURL
        },
        lazyload: {
            type: Boolean,
            default: false
        },
        background: {
            type: String,
            default: 'transparent'
        }
    },
    watch: {
        src: function src() {
            this.isLoading = true;
            this.isErrored = false;
        }
    },
    methods: {
        onload: function onload() {
            this.isLoading = false;
            this.isErrored = false;
        },
        onerror: function onerror() {
            this.isLoading = false;
            this.isErrored = true;
        }
    },
    render: function render() {
        var h = arguments[0];
        var src = this.src,
            alt = this.alt,
            fillMode = this.fillMode,
            width = this.width,
            height = this.height,
            radius = this.radius,
            round = this.round,
            placeholder = this.placeholder,
            lazyload = this.lazyload,
            block = this.block;
        return h(
            'div',
            {
                class: b({
                    round: radius > 0 || round
                }),
                style: {
                    background: this.background,
                    borderRadius: ''.concat(radius, 'px'),
                    width: ''.concat(width, 'px'),
                    height: ''.concat(height, 'px'),
                    display: block ? 'block' : ''
                }
            },
            [
                h(
                    InnerLazyload,
                    {
                        attrs: {
                            active: lazyload
                        }
                    },
                    [
                        h('img', {
                            attrs: {
                                alt: alt,
                                height: height,
                                src: src,
                                width: width
                            },
                            class: b('img', _defineProperty({}, 'fm-'.concat(fillMode), fillMode)),
                            on: {
                                error: this.onerror,
                                load: this.onload
                            }
                        })
                    ]
                ),
                h(
                    LoadingWrapper,
                    {
                        attrs: {
                            placeholder: placeholder,
                            show: this.isLoading
                        }
                    },
                    [this.$slots.loading]
                ),
                h(
                    ErroredWrapper,
                    {
                        attrs: {
                            show: this.isErrored
                        }
                    },
                    [
                        this.$slots.error ||
                            h('icon', {
                                attrs: {
                                    name: 'close-2',
                                    size: 30
                                }
                            })
                    ]
                )
            ]
        );
    },
    components: {
        icon: Icon,
        lazyload: Lazyload
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
